<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="d-flex form-heading title-section form-section">
              <p class="form-title text-center">
                THE OREP RISK PURCHASING GROUP MEMBERSHIP AGREEMENT
              </p>
            </article>
            <article class="input-section form-section">
              <div >
                <p class="mb-3" style="font-size: 19px;background: yellow">
                  There is no Cost or Obligation to Obtain a Quote. This RPG Agreement is binding only if you decide to purchase your Quote.  Your No Obligation Quote is on the next page.
                </p>
                <p class="mb-3">
                  This Professional Services Agreement & Broker Agreement (“Agreement”) is effective as of the date this agreement is signed,
                  (“Effective Date”), by and between the undersigned (“Client”) and OREP Insurance Services, LLC (“Broker”). Under this Agreement, (a) Client appoints Broker as Client’s insurance broker of record to transact insurance
                  business on behalf of the Client, and (b) the parties agree to separate services to be provided by Broker to Client and related fees, as
                  set forth herein.
                </p>
                <p class="mb-3">
                  <strong>ADDRESSES OF PARTIES: </strong>
                  RPG has its principal offices at 8880 Rio San Diego Drive, Suite 800 San Diego, CA 92108. Applicant has its principal
                  residence, office or business at the mailing address listed on the Application.
                </p>
                <p class="mb-3">
                  <strong>RECITALS:</strong>
                  The RPG is a “risk purchasing group,” domiciled in Illinois and formed pursuant to the Liability Risk Retention of 1986 (as amended)(15
                  U.S.C. 3910 et. seq.)(“Act”) and Illinois Law. The purpose of the RPG, in part, is to purchase liability insurance on a group basis for its Members in
                  order to cover the similar or related liability exposure(s) to which the Members of RPG are exposed by virtue of similar business operations. The
                  Applicant represents that Applicant is engaged in business related to the sale, inspection, and appraisal of real estate. The Applicant desires to
                  become a Member of RPG, in part, for the purpose of obtaining insurance coverage available exclusively to Members of RPG.
                </p>
                <p class="mb-3">
                  <strong>AGREEMENT: </strong>
                  In consideration of the mutual promises and covenants set forth herein, and for other good and valuable consideration, the receipt
                  and sufficiency of which is hereby acknowledged, Applicant and RPG agree as follows:
                </p>
                <p class="mb-3">
                  1. Acceptance of Terms & Conditions of Membership Agreement. By accepting this Agreement, Applicant agrees to become a Member of RPG and
                  to accept, and be bound by the terms and conditions of membership as set forth in this Agreement.
                </p>
                <p class="mb-3">
                  2. MEMBERSHIP: RPG may, in its sole discretion, offer various benefits to its Members, including access to industry publications, professional
                  education and training, and special pricing on additional products and services. At its sole discretion, and at any time, RPG may add, change, or
                  discontinue any benefit program that it offers to its Members. One of the primary benefits provided to Members of RPG is access to an insurance
                  program available exclusively to Members of RPG (the “Insurance Program”).</p>
                <p class="mb-3">
                  3. ADMINISTRATOR: RPG shall select and engage an administrator (the “Administrator”) to administer the business affairs of the RPG. RPG shall
                  negotiate the Administrator’s compensation. Applicant agrees to accept and not dispute RPG’s Administrator and the compensation to be paid by
                  RPG for the Administrator’s services. Currently, the Administrator is OREP Risk Management LLC. RPG has the sole authority to (a) select and
                  terminate the Administrator and (b) negotiate the services to be rendered by, and compensation to be paid to, the Administrator.
                </p>
                <p class="mb-3">
                  4. AGENT: RPG may select an agent or agents (the “Agent”) to administer its Insurance Program. RPG shall negotiate Agent’s compensation.
                  Applicant agrees to accept and not dispute RPG’s selection of Agent and the compensation to be paid by RPG for such services. RPG has authorized
                  Agent’s compensation plan. RPG has the sole authority and discretion to (a) select and terminate the Agent and (b) negotiate the compensation to
                  be paid for Agent’s services. RPG’s current Agent is OREP Insurance Services, LLC.</p>
                <p class="mb-3">
                  5. RIGHTS: Applicant’s only rights as a Member of RPG shall be to apply for and purchase liability insurance on a group basis. Applicant shall have no
                  voting rights or other rights whatsoever as a Member or otherwise with respect to RPG. Without limiting the generality of the foregoing, Applicant
                  shall have no right as a Member of RPG or otherwise under the: 1. Articles of Incorporation, bylaws, or other corporate documents of RPG; or 2.
                  general corporation laws of any state, including any state in which Applicant or RPG is domiciled or have operations.
                </p>
                <p class="mb-3">
                  6. TERM: Applicant’s membership in RPG shall commence on the effective date of insurance coverage and shall terminate upon the earliest to
                  occur of the following events: a. Applicant’s written resignation from RPG; b. Applicant’s failure to pay premiums, Risk Purchasing Group
                  Membership Dues (“Dues”), or taxes to Administrator on behalf of RPG when due; c. written notice of termination sent from RPG or Administrator
                  to Applicant, which RPG may give for any reason whatsoever, including, without limitation, any change in Applicant’s business that, in RPG’s sole
                  determination, could jeopardize the homogeneity of RPG; d. expiration date of insurance coverage under the Insurance Program;</p>
                <p class="mb-3">
                  7. PURPOSE: A primary purpose of the OREP RISK PURCHASING GROUP, administered by OREP RISK MANAGEMENT LLC, shall be to provide each of
                  its Members, regardless of such Member’s size, with the ability to obtain liability insurance at a reasonable cost.
                </p>
                <p class="mb-3">
                  8. DUES: The RPG intends to charge annual dues. The Dues charged to each Member each year may vary from Member to Member and may bear
                  no relation to the premium payable by the member, or the insurance exposures or operations of the Member. The amount of the Dues charged
                  shall be within the sole discretion of Administrator and RPG and can represent between 10% and 20% of the total annual cost to the member.
                </p>
                <p class="mb-3">
                  9. NATURE OF DUES: Dues are not insurance-related fees and are instead used to fund the operations and pay the expenses of the RPG, including
                  part or all of the compensation paid to the Administrator or agent. Dues charged to Applicant are not charged to Applicant in exchange for a policy
                  of liability insurance. Dues received by the Administrator on behalf of RPG shall immediately become part of RPG’s general operating funds, which
                  may be utilized, in the course of the management of RPG’s business affairs, as RPG or the Administrator deems appropriate.
                </p>
                <p class="mb-3">
                  10. RPG shall select the general insurance terms, conditions, and exclusions of the Insurance Program in its sole discretion, including but not limited
                  to Terrorism Exclusions, Professional Liability Exclusions, Fungi & Bacteria Exclusions, Pollution Exclusions, and more. Applicant agrees to accept
                  RPG’s decisions and grants authority to RPG to accept or decline coverage on Applicant’s behalf. Applicant is responsible for reviewing the policy
                  terms (including premium), conditions, and exclusions. Applicant may then decide if it wishes to purchase or to maintain coverage as presented.
                </p>
                <p class="mb-3">
                  11. By Accepting this Agreement, Applicant accepts and agrees, without limitation or qualification, to the terms and conditions of this Agreement.
                  Membership in RPG is voluntary and should be entered into only after careful and thorough review of the Agreement.
                </p>
                <p class="mb-3">
                  12. Entire Agreement & Merger of Previous Agreements. This Agreement, together with the Application and the Certificate, constitutes the entire
                  agreement between the parties and supersedes all previous agreements entered into between the parties hereto with respect to its subject
                  matter; and all such previous agreements, whether oral or written, are hereby merged into, and superseded by, this instrument.
                </p>
                <p class="mb-3">
                  13. Not Assignable. Applicant agrees that its rights under this Agreement are not assignable without the express written consent of RPG.
                </p>
                <p class="mb-3">
                  14. Jurisdiction and Governing Law. This Agreement is governed by and shall be construed in accordance with the laws of the State of Illinois,
                  without regard to any applicable choice of law provisions, and Applicant and RPG hereby submit to the exclusive jurisdiction of the courts of Illinois.
                </p>
                <p class="mb-3" style="font-size: 19px;background: yellow">
                There is no Cost or Obligation to Obtain a Quote. This RPG Agreement is binding only if you decide to purchase your Quote.  Your No Obligation Quote is on the next page.
                </p>
                <p>
                  <strong>Consent to Electronic Signature: </strong>
                  I Wish to Sign Electronically. By typing my name below, I hereby sign my application and consent to the use of electronic signature for the purposes of this insurance application. (Please email <a href="mailto:info@orep.org" target="_top">info@orep.org</a> if you do not consent to Electronic Signature.)
                </p>
                <div class="row mb-4">
                  <div class="col-md-1 d-flex align-items-center">
                    <label class="orep-label m-0">
                      CLIENT
                    </label>
                  </div>
                  <div class="col-md-2">
                    <input
                        type="checkbox"
                        name="emailPolicy"
                        class="orep-radio w-40"
                        v-model="axApplication.emailPolicy"
                    >
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6 form-inline">
                    <label for class="orep-label mb-0 mr-2">
                      Name:
                    </label>
                    <input
                        type="text"
                        name="fullname"
                        class="orep-text-input form-control"
                        :value=axApplication.fullLegalNameOfAppraiser
                        disabled>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6 form-inline">
                    <label for class="orep-label mb-0 mr-2">
                      Signature:
                    </label>
                    <input
                        type="text"
                        name="clientSignature"
                        class="orep-text-input form-control"
                        v-model="axApplication.clientSignature"
                        v-validate="'required'"
                        placeholder="Type Your Name to Sign"
                        @input="validateBeforeSubmit()"
                    >
                    <span
                        v-show="errors.has('clientSignature')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('clientSignature') | filterText }}</span>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6 form-inline">
                    <label for class="orep-label mb-0 mr-2">
                      Date:
                    </label>
                    <h5 class="m-0">{{formattedCurrentDate()}}</h5>
                  </div>
                </div>

              </div>
            </article>
            <article v-if="this.$store.getters.getHostname !== 'www.liabilityinsuranceapps.com'" class="d-flex form-heading title-section form-section center-block" style="flex-direction: column; align-items: center;">
              <label for="hear_about_us" class="orep-label proposal-title blue-color" style="text-align: center; margin-bottom: 10px;margin-top: 30px;">
                <strong>How Did You Hear About Us?</strong>
              </label>
              <select
                  class="orep-select"
                  style="height: 40px; width: 383px;"
                  name="hear_about_us"
                  v-model="axApplication.hearAboutUs"
                  v-validate="'required'"
                  @change="validateBeforeSubmit()"
              >
              <option v-for="(item, key) in hear_about_us" :value="item">
                {{ item }}
              </option>
              </select>
              <span
                  v-show="errors.has('hear_about_us')"
                  class="help is-danger form-errors text-danger"
              >
              {{ errors.first('hear_about_us') | filterText }}
            </span>

              <div class="input-section">
                <input
                    v-if="axApplication.hearAboutUs === 'Other'"
                    type="text"
                    name="hearAboutUsOtherDetails"
                    class="orep-text-input mr-1"
                    v-model="axApplication.hearAboutUsOtherDetails"
                    placeholder="Please Provide Details"
                    @input="validateBeforeSubmit()"
                >
                <span
                    v-show="errors.has('hearAboutUsOtherDetails')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('hearAboutUsOtherDetails') | filterText }}</span>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'ax-application-5'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('ax-application-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('ax-application-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('ax-application-3')"></button>
              <button class="pagination-dots" @click="navigateToPrev('ax-application-4')"></button>
<!--              <button class="pagination-dots" @click="navigateToPrev('ax-application-5')"></button>-->
              <span class="pagination-dots pagination-current"></span>
            </article>
            <button
              type="submit"
              :disabled="!state.pageSixIsValid"
              :class="{submitDisabled: !state.pageSixIsValid}"
              class="next-btn mont spaced pull-right"
              @click="formSubmit()"
            >Submit</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Submitting application...Please wait 5-10 seconds..</span>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import moment from 'moment';
import {APP_STATUS, HEAR_ABOUT_US_AX_APPRAISERS, STATES, YEARS} from '../../utils/constants';

export default {
  name: 'ax-application-6',
  data() {
    return {
      hear_about_us: HEAR_ABOUT_US_AX_APPRAISERS,
      loading: false
    };
  },
  computed: {
    axApplication() {
      return this.$store.state.axApplication.axApplication;
    },
    state() {
      return this.$store.state.axApplication;
    },
    errorMsg() {
      return this.$store.state.axApplication.errorMsg;
    },
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.loading = false;
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg,
          });
        }
      },
    },
  },
  methods: {
    navigateToPrev(route) {
      this.$router.push({
        name: route,
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.state.pageSixIsValid = true;
          return;
        }
        this.state.pageSixIsValid = false;
      });
    },

    formattedCurrentDate() {
      return moment(this.axApplication.appraiserEsignatureDatetime).format('MM/DD/YYYY');
    },

    formSubmit() {
      this.loading = true;
      this.state.axApplication.customer.appStatus = APP_STATUS.Completed;
      this.$store.dispatch('axApplication/createAxApplication');
    },
  },

  mounted() {
    $('html, body').animate({
      scrollTop: $('.page-content').offset().top,
    }, 500);
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf('req') !== -1) {
          return 'This field is required';
        }
        return x.replace('_', ' ');
      }
    },
  },

  components: {},
};
</script>

<style scoped>
mark {
  background-color: yellow;
  color: black;
}
  strong {
    text-decoration: underline;
  }
  .form-inline > label {
    width: 82px;
    text-align: left;
  }
  .form-heading > p {
    font-size: 35px;
    width: 100%;
    text-align: center;
    margin: 0;
  }
  .table-left-border {
    border-left: 1px solid black;
  }
  .table-border {
    border: 1px solid black;
  }
</style>
